import React, { useEffect,useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import {ThreeDots} from 'react-loader-spinner';
import axios from 'axios';
import "../../App.css";
import {properties} from "../../utils/properties";
import { useNavigate } from "react-router-dom";

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";

//INTERVENIRE DOVE CI SONO I TODO

export default function Init() {

  const navigate = useNavigate();
  const [loading, setLoading]= React.useState(true); 


  const [notificationAvailable, setNotificationAvailable] = useState(null);
  const [dialog, setDialog] = useState(null);
  
  /*
  const handleNotificationAvailable = (dateString,textString, id) => {    
      //console.log("HNA",dateString, textString);
    return new Promise((resolve) => {

      const handleChoice = (choice, id) => {
        console.log("called", choice, id);
        var xhr = new XMLHttpRequest();                        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/updateStatoFieldUser.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                                                    
                      console.log("OK",xhr);                      
                      const response = JSON.parse(xhr.responseText);
                      setDialog(null);
                      resolve(choice);
                        
                }
              }        
        };

        xhr.onerror = function (e) {
            console.error("Error 27", xhr);
            //localStorage.clear();          
            setDialog(null);
            resolve(choice);  
            navigate("/login");
        };
       
      let urlEncodedData = "id=" + id+ "&value=" + choice;  
      xhr.send(urlEncodedData);
      };

    setDialog(      
      <Dialog open={true} 
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          handleChoice(0,id); 
        }        
      }}
      fullWidth maxWidth="sm">
              <DialogTitle sx={{ textAlign: "center" }}>
              {dateString}
              </DialogTitle>
              <DialogContent dividers>
                <Typography sx={{ textAlign: "justify", fontSize: 18 }}>
                  {textString}
                </Typography>
              </DialogContent>
              <DialogActions sx={{ flexDirection: "column", gap: 1, alignItems: "stretch", p: 2 }}>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }}  variant="contained" color="success"  onClick={() => handleChoice(1,id)}>✅ CONFERMO LA PARTECIPAZIONE IN PRESENZA</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="success"  onClick={() => handleChoice(2,id)}>💻 CONFERMO LA PARTECIPAZIONE DA REMOTO</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit" onClick={() => handleChoice(4,id)}>⏳ NON SO ANCORA, RICORDAMELO PIU' TARDI</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit"  onClick={() => handleChoice(3,id)}>❌ NON RIESCO A PARTECIPARE ALLA SEDUTA</Button>
              </DialogActions>
      </Dialog>
      );
    });

  }
*/

//TODO
/*
useEffect(() => {
  
  if (localStorage.getItem("ruolo") !== "2" && localStorage.getItem("ruolo") !== "20" && localStorage.getItem("ruolo") !== "21") {  
      const scelta="nessunaNotifica";
      setNotificationAvailable(scelta);
  }
  else{  
      let mounted = true;
      const run = () => {
        const xhr = new XMLHttpRequest();
        const url = properties.productionUrl + properties.productionUrlSuffix + "/core/rest/checkNotifications.php";

        xhr.open("POST", url, true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = async function () {
          console.log("POST",xhr.readyState,xhr.status);
          if (xhr.readyState === 4 && xhr.status === 200) {
            try {
              const obj = JSON.parse(xhr.responseText);
              console.log("ID",obj.id)
              if (!mounted) return;
              
              const scelta = await handleNotificationAvailable(obj.date ?? "", obj.text ?? "", obj.id ?? "");
              console.log("Scelta utente:", scelta);

              if (!mounted) return;
              if (scelta != null) setNotificationAvailable(scelta);
            } catch (err) {
              console.error("JSON parsing error:", err);
            }
          }
          if (xhr.readyState === 4 && xhr.status === 404) {
            //NO NOTIFICHE
            const scelta="nessunaNotifica";
            setNotificationAvailable(scelta);
          }

        };

        xhr.onerror = function () {
          console.error("XHR network error");
        };

        xhr.send(null);
      };
      run();


  return () => {
    mounted = false;
  };
}
}, []);

*/


  useEffect(() => {
    //TODO
    
    console.log("UE2");
    //if(notificationAvailable === null) return;
    
    if(!window.cordova){            
    //CHECK AUTHENTICATIONnpo
       
        var xhr = new XMLHttpRequest();                        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/ping.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                                        
                    if( properties.verboseLog==1)
                      console.log("OK",xhr);
                    try {
                        const response = JSON.parse(xhr.responseText);
                        if (response.version && response.version !== properties.version && properties.productionUrlSuffix != "/php_demo") {
                          console.log(
                            `Nuova versione disponibile (${response.version}), ricarico...`
                          );
                          window.location.reload(true); 
                        }
                    } catch (err) {
                        console.error("Errore nel parsing della risposta:", err);
                      }
                    
                    
                    //IF PREVIEWERS                                           
                    var error=false;
                    var lastId=undefined;
                    var newUI=false;
                    var isPreviewer=false;
                    var isConsiglio=false;
                    if(localStorage.getItem("new_ui")=== undefined || localStorage.getItem("new_ui")=== null || localStorage.getItem("new_ui")=== "false"){        
                      newUI=false;
                    }
                    else{
                      newUI=true;
                    }
                    if(localStorage.getItem("ruolo")=='20'){
                      isConsiglio=true;                      
                    }

                    if(isConsiglio){
                      if( properties.verboseLog==1)
                        console.log("consiglio only");              
                      navigate("/consiglio",{ replace: true });  
                    }
                    else{                    
                      if( properties.verboseLog==1)
                        console.log("After");
                      if(localStorage.getItem("ruolo")=='15'|| localStorage.getItem("ruolo")=='12'||localStorage.getItem("ruolo")=='10'||
                        localStorage.getItem("ruolo")=='5'||localStorage.getItem("ruolo")=='4'||localStorage.getItem("ruolo")=='1'){
                        isPreviewer=true;      
                    }                    
                    if( properties.verboseLog==1)
                      console.log("Info:"+ newUI+ " "+isPreviewer);    
                    
                    if(isPreviewer){                      
                        if( properties.verboseLog==1)
                          console.log("Info2: Inside isPReviewer");    
                        axios.get(properties.productionUrl+properties.productionUrlSuffix+'/core/rest/getLast.php?edited', {withCredentials: true})
                        .then(res => {                      
                          if(res.data==undefined){                      
                            error=true;
                          }
                          if(res.data=="\n\n" || res.data==""){                        
                            error=true;
                          }
                          if(!error){
                            lastId = res.data;
                          }                    
                          if( properties.verboseLog==1)
                            console.log("Fascicolo",error, lastId, newUI);
                          if(lastId != undefined) {
                            //c'è un fascicolo in preview
                            if(newUI){                              
                              navigate("/fascicoli/"+lastId+"/summary",{ replace: true });  
                            }
                            else{                              
                                navigate("/fascicoli/"+lastId,{ replace: true });  
                            }
                          }
                          else{ 
                            if(newUI){                              
                                  navigate("/calendar",{ replace: true });  
                            }
                            else{                              
                                  navigate("/fascicoli",{ replace: true });  
                            }          
                          }                                                            
                      }).catch(function (res) {            
                        console.log("Errore 77",res);
                        if(newUI){                      
                              navigate("/calendar",{ replace: true });  
                        }
                        else{                          
                              navigate("/fascicoli",{ replace: true });  
                        }          
                      });
                    }
                    //FINE IF PREVIEWERS
                    else{
                        if(localStorage.getItem("new_ui")==="true"){                            
                                navigate("/calendar",{ replace: true });  
                        }
                        else{                            
                              navigate("/fascicoli",{ replace: true });  
                        }    
                    }
              }//ELSE CONSIGLIO                
            } else {
                console.error("Error 17", xhr); 
                localStorage.clear();                                   
                navigate("/login");
            }
        }
        };

        xhr.onerror = function (e) {
            console.error("Error 27", xhr);
            localStorage.clear();            
            navigate("/login");
        };
         
        let urlEncodedData = null; 
        xhr.send(urlEncodedData);
    //CHECK AUTHENTICATION
    }
    
    if (window.cordova) {
          var onSuccess = function(response)
          {
            if( properties.verboseLog==1)
              console.log("OK LOGIN 33");
            var obj=JSON.parse(response);
            var ruolo = obj.Ruolo;

            var error=false;
            var lastId=undefined;
            var newUI=false;
            var isPreviewer=false;
            var isConsiglio=false;
            if(localStorage.getItem("new_ui")=== undefined || localStorage.getItem("new_ui")=== null || localStorage.getItem("new_ui")=== "false"){        
              newUI=false;
            }
            else{
              newUI=true;
            }
            if(ruolo=='20'){
              isConsiglio=true;                      
            }

            if(isConsiglio){
              if( properties.verboseLog==1)
                console.log("consiglio only");              
              navigate("/consiglio",{ replace: true });  
            }
            else{      
                if(localStorage.getItem("new_ui")==="true"){                    
                        navigate("/calendar",{ replace: true });  
                }
                else{                    
                    navigate("/fascicoli",{ replace: true });  
                }    
            }
        }

          var onError = function() {}

          window.getInfo3(onSuccess, onError);
    }
              
    
},
//TODO
  // [notificationAvailable]);
[]);



  return (
    <div key={uuidv4()}> 
    {loading ? (
      <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
      marginLeft: "auto", marginRight: "auto" }}> 
       <ThreeDots color="#30720f" height='350' width='150'/>
       </div> 
      ):(
        <></>)
    }
      <div>
        {dialog}        
        </div>         
    </div>
  );
  
}